export default __webpack_public_path__ + "static/media/90.6ed85543.gif";